// @flow
// @jsx h
import { h, Component } from "preact";

import Phone, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/rrui.css";
import "react-phone-number-input/style.css";

import styles from "./PhoneInput.scss";

type PhoneInputProps = {
  name: string,
  id: string,
  value: string,
  onChange: Function,
  placeholder: string,
  locale?: string,
  onBlur?: Function,
  countryPhone?:string
};

type PhoneInputState = {
  internationalValue: string,
  country: string
};

export default class PhoneInput extends Component<
  PhoneInputProps,
  PhoneInputState
> {
  constructor(props: PhoneInputProps) {
    super(props);
    this.state = {
      internationalValue: this.props.value || "",
      country: this.getCountryFromLocale(this.props.locale || "fr")
    };
  }

  getCountryFromLocale(locale: string) {
  return locale.toUpperCase() === "EN"
    ? "GB"
    : (locale.toUpperCase() || "FR");
}

  setInternationalValue(phone: string) {
    this.setState({ internationalValue: phone });
    this.props.onChange({
      target: {
        type: "phone",
        name: this.props.name,
        value: phone,
        isValid: isValidPhoneNumber(phone)
      }
    });
  }

  onBlur(phone: string) {
    if(this.props.onBlur){
      this.props.onBlur({
        target: {
          type: "phone",
          name: this.props.name,
          value: phone,
          isValid: isValidPhoneNumber(phone)
        }
      });
    }
  }

componentDidUpdate(prevProps: PhoneInputProps) {
  if (prevProps.locale !== this.props.locale && this.props.countryPhone == '') {
    this.setState({
      country : this.getCountryFromLocale(this.props.locale)
    });
  }
}

  componentWillReceiveProps(nextProps: PhoneInputProps) {
    if (nextProps.locale !== this.props.locale && this.props.countryPhone == '') {
      if (nextProps.locale.toUpperCase() === "EN") {
        this.setState({ country: "GB" });
      } else {
        this.setState({ country:  nextProps.locale.toUpperCase() });
      }
    } else if(nextProps.countryPhone !== this.props.countryPhone){
       this.setState({ country:  nextProps.countryPhone });
    }

    if (nextProps.value !== undefined && nextProps.value !== this.props.value) {
      this.setInternationalValue(nextProps.value);
    }
  }

  render() {
    return (
      <Phone
        id={this.props.id}
        name={this.props.name}
        placeholder={this.props.placeholder}
        value={this.state.internationalValue}
        country={this.state.country}
        flagsPath="https://flagicons.lipis.dev/flags/4x3/"
        onChange={value => this.setInternationalValue(value)}
        onBlur={event => {
          // event.target.value contient la valeur du champ
          this.onBlur(event.target.value);
        }}
        convertToNational
        className={styles.phoneElement}
        inputClassName={styles.phoneInput}
      />
    );
  }
}
